import {
      GET_FTC_CALCULATION,
      GET_FTC_CALCULATION_LIST,
      POST_FTC_CALCULATION,
      PUT_FTC_CALCULATION,
      DELETE_FTC_CALCULATION
    } from "../constants/actionTypes";

    const defaultState = {
      ftcComputationArr: [],
      ftcComputation: {}
    };

    let data=[]
    export default (state = defaultState, action) => {
      try {
        switch (action.type) {
          case GET_FTC_CALCULATION_LIST:
            return {...state, ftcComputationArr: Array.isArray(action.payload) ? [...action.payload] : []};
          case GET_FTC_CALCULATION:
            return {...state, ftcComputation: {...action.payload}};
          case POST_FTC_CALCULATION:
            return {...state, ftcComputationArr: [...state?.ftcComputationArr, action.payload]};
          case PUT_FTC_CALCULATION:
            data = [...state?.ftcComputationArr];
            const index = data?.findIndex(
              (ftc) => ftc?.id === action.payload?.id,
            );
            if (index != -1) data[index] = { ...action?.payload };
            return {...state, ftcComputationArr: [...data]};
          case DELETE_FTC_CALCULATION:
            data = [...state?.ftcComputationArr];
            const newData = data?.filter(
              (ftc) => ftc.id != action.payload,
            );
            return {...state, ftcComputationArr: [...newData]};
          default:
            return state;
        }
      } catch (error) {
        throw new Error(error);
      }
    };